module.exports = __webpack_public_path__ + "img/card-img_2.9482d2bf.png";